import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Phase 35.3 — read-only 40×40 thumbnail of an FG item's product image, used
 * inside the line-items table on the Quotation and Transfer Order forms.
 * The image endpoint requires auth, so we fetch it via `api` as a blob and
 * render an object URL. Falls back to a blank cell for non-FG items or FG
 * items without an uploaded image.
 */
export function LineImageThumb({ item, testid }) {
  const [preview, setPreview] = useState("");

  useEffect(() => {
    let revoke = "";
    setPreview("");
    if (!item || item.type !== "FG" || !item.image_storage_path) return () => {};
    (async () => {
      try {
        const res = await api.get(`/items/${item.id}/image`, { responseType: "blob" });
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setPreview(url);
      } catch {
        setPreview("");
      }
    })();
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [item?.id, item?.image_storage_path, item?.type]);

  if (!preview) {
    // Blank cell — no placeholder icon per spec
    return <span className="inline-block w-10 h-10" data-testid={testid ? `${testid}-empty` : undefined} />;
  }
  return (
    <img
      src={preview}
      alt=""
      className="w-10 h-10 object-contain rounded border border-slate-200"
      data-testid={testid}
    />
  );
}

export default LineImageThumb;
